const App = {
  SetBackground: () => {
    $("[setBackground]").each(function () {
      var background = $(this).attr("setBackground");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    });
    $("[setBackgroundRepeat]").each(function () {
      var background = $(this).attr("setBackgroundRepeat");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-repeat": "repeat",
      });
    });
  },
  EqualHeightElement: (el) => {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
      thisHeight = $(this).height();
      if (thisHeight > height) {
        height = thisHeight;
      }
    });
    $(el).height(height);
  },
  ScrollTo: (y) => {
    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000
    );
  },
  Init: () => {
    App.ScrollTo();
    App.SetBackground();
  },
};

function InitSlider() {
  if ($(".product-details-slider").length) {
    var sliderThumbs = new Swiper(".thumbs", {
      direction: "vertical",
      slidesPerView: 3,
      spaceBetween: 20,
      observer: true,
      grabCursor: true,
      observeParents: true,
      breakpoints: {
        992: {
          direction: "horizontal",
          slidesPerView: 3,
        },
      },
      on: {
        init: function () {
          setSlideHeight(this);
        },
        slideChangeTransitionEnd: function () {
          setSlideHeight(this);
        },
      },
    });
    var sliderImages = new Swiper(".gallery", {
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      observer: true,
      observeParents: true,
      thumbs: {
        swiper: sliderThumbs,
      },
    });
    function setSlideHeight(that) {
      $(".thumbs .swiper-slide").css({ height: "auto" });
      var currentSlide = that.activeIndex;
      var newHeight = $(that.slides[currentSlide]).height();

      $(".thumbs .swiper-wrapper,.thumbs .swiper-slide").css({
        height: newHeight,
      });
      that.update();
    }
  }
  var projectsSlider = new Swiper(".our-featured-projects .swiper-container", {
    slidesPerView: 2.3,
    spaceBetween: 25,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".our-featured-projects .swiper-next",
      prevEl: ".our-featured-projects .swiper-prev",
    },
    breakpoints: {
      575: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
    },
  });
  var awardsSlider = new Swiper(".awards-and-accolades .swiper-container", {
    slidesPerView: 2.3,
    spaceBetween: 25,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".awards-and-accolades .swiper-next",
      prevEl: ".awards-and-accolades .swiper-prev",
    },
    pagination: {
      el: ".awards-and-accolades .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
    breakpoints: {
      575: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
    },
  });

  var teamSlider = new Swiper(".our-leadership-team .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 45,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".our-leadership-team .swiper-next",
      prevEl: ".our-leadership-team .swiper-prev",
    },
    pagination: {
      el: ".our-leadership-team .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
    breakpoints: {
      992: {
        spaceBetween: 30,
      },
      575: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      575: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  });
  var ourClienteleSlider = new Swiper(".our-clientele .swiper-container", {
    slidesPerView: 6,
    spaceBetween: 30,
    slidesPerColumn: 2,
    slidesPerGroup: 6,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".our-clientele .swiper-next",
      prevEl: ".our-clientele .swiper-prev",
    },
    pagination: {
      el: ".our-clientele .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
        spaceBetween: 20,
        slidesPerGroup: 6,
      },
      767: {
        slidesPerView: 4,
        spaceBetween: 20,
        slidesPerGroup: 4,
      },
      575: {
        slidesPerView: 3,
        spaceBetween: 20,
        slidesPerGroup: 3,
      },
    },
  });
}

function Headers() {
  $(document).on("click", ".toggle-btn", function () {
    $(this).toggleClass("active");
    $(".mobile-nav-inner").toggleClass("active");
    $(".header .overlay").toggleClass("active");
  });
  $(document).on("click", ".header .overlay", function () {
    $(this).removeClass("active");
    $(".mobile-nav-inner").removeClass("active");
    $(".toggle-btn").removeClass("active");
  });

  $(document).on(
    "click",
    ".mobile-nav-inner .has-dropdown .icon-dropdown",
    function (event) {
      event.preventDefault();
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).parents(".has-dropdown").removeClass("active");
        $(this).parents(".has-dropdown").find(".nav-sub").slideUp();
      } else {
        $(".header .nav-sub").slideUp();
        $(".icon-dropdown").removeClass("active");
        $(".has-dropdown").removeClass("active");
        $(this)
          .toggleClass("active")
          .parents(".has-dropdown")
          .find(".nav-sub")
          .slideDown();
        $(this).parents(".has-dropdown").toggleClass("active");
      }
    }
  );
}
//mapping
function mappings() {
  if ($(".header").length) {
    var moveNav = new MappingListener({
      selector: ".header .menu",
      mobileWrapper: ".mobile-nav-inner",
      mobileMethod: "appendTo",
      desktopWrapper: ".header .logo-box",
      desktopMethod: "insertAfter",
      breakpoint: 1200,
    }).watch();
  }
}
function accordion() {
  if ($(".accordions").length) {
    $(".accordion-item.active").find(".accordion-content").show();
    $(".accordion-heading").on("click", function () {
      if (!$(this).parent().is(".active")) {
        $(this)
          .parent()
          .toggleClass("active")
          .children(".accordion-content")
          .slideToggle(500)
          .parent()
          .siblings(".active")
          .removeClass("active")
          .children(".accordion-content")
          .slideToggle(500);
        $(this).find(".arrow .txt").text("Show less");
      } else {
        $(this).parent().toggleClass("active");
        $(this).next().slideToggle(500);
        $(this).find(".arrow .txt").text("Show more");
      }
    });
  }
}

function jarallax() {
  $(".jarallax").jarallax({
    speed: 0.2,
    disableParallax: / iPad | iPhone | iPod | Android /,
    disableVideo: / iPad | iPhone | iPod | Android /,
  });
}

function myTabs() {
  $(".my-tabs").each(function () {
    var $this = $(this);
    $this.find(".tabs-nav li:first").addClass("active");
    $this.find(".tab-content:first").show();
    $this.find(".tabs-nav li").click(function () {
      var corresponding = $(this).data("tab");
      $this.find(".tab-content").hide();
      $this.find(".tab-content." + corresponding).show();
      $this.find(".tabs-nav li").removeClass("active");
      $(this).addClass("active");
      $(".slick-container").slick("setPosition", 0);
    });
  });
}
function selectUi() {
  $(".dropdown").on("click", ".dropdown-select", function () {
    if ($(this).parents(".dropdown").hasClass("open")) {
      $(this).parents(".dropdown").removeClass("open");
      $(this).siblings(".dropdown-list").hide();
    } else {
      $(".dropdown").removeClass("open");
      $(this).parents(".dropdown").addClass("open");
      $(".dropdown-list").hide();
      $(this).siblings(".dropdown-list").show();
    }
  });
  var allOptions = $(".dropdown-list").children(".dropdown-item");
  $(".dropdown-list").on("click", ".dropdown-item", function () {
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $(this)
      .parents(".dropdown")
      .find(".dropdown-selected")
      .css("color", "#212429")
      .html($(this).html());

    $(this).parents(".dropdown-list").toggle();
    $(this).parents(".dropdown").toggleClass("open");
    $("input#inputInit").val($(this).data("val"));
  });
  var $menu = $(".dropdown");

  $(document).mouseup(function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
      $menu.removeClass("open");
      $menu.find(".dropdown-list").hide();
    }
  });
}

function checkWidth() {
  var $window = $(window);
  var windowsize = $window.width();
  if (windowsize >= 1200) {
    $(".header").find(".nav-sub").removeAttr("style");
    $(".header").find(".mega-panel").removeAttr("style");
  }
  if (windowsize >= 1200) {
    $(".header .overlay").removeClass("active");
    $(
      ".header .mobile-nav-inner,.has-dropdown,.has-mega,.icon-dropdown,.icon-dropdown-2,.has-child"
    ).removeClass("active");
  }
  setTimeout(function () {
    $(".btn-position").each(function () {
      var imgHeight = $(this).find(".box-img").outerHeight();
      var btnHeight = $(this).find(".swiper-next").outerHeight();
      $(this)
        .find(".swiper-next,.swiper-prev")
        .css("top", imgHeight / 2);
    });
  }, 100);
}
function replaceSvg() {
  $("img.svg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    $.get(
      imgURL,
      function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });
}
function adjustProductAmount() {
  $(".plus").on("click", function () {
    $(this)
      .parents(".amount,.amount-2")
      .find(".input")
      .val(+$(this).parents(".amount,.amount-2").find(".input").val() + 1);
    $(".woocommerce-cart-form .update-cart.btn").removeAttr("disabled");
  });
  $(".minus").click(function () {
    if ($(this).parents(".amount,.amount-2").find(".input").val() > 1) {
      if ($(this).parents(".amount,.amount-2").find(".input").val() > 1)
        $(this)
          .parents(".amount,.amount-2")
          .find(".input")
          .val(+$(this).parents(".amount,.amount-2").find(".input").val() - 1);
    }
  });
}
function fixedNav() {
  var nav = $(".header");
  if (nav.length) {
    var offsetTop = nav.offset().top,
      TH = $(".header").height(),
      headerHeight = nav.height(),
      injectSpace = $("<div />", {
        height: headerHeight,
      }).insertAfter(".header");
    injectSpace.hide();
    $(window).on("load scroll resize", function () {
      if ($(window).scrollTop() > offsetTop) {
        nav.addClass("fixed");
        injectSpace.show();
      } else {
        nav.removeClass("fixed");
        injectSpace.hide();
      }
    });
  }
}

function uploadPhoto() {
  $("input:file").on("change", function () {
    var target = $(this);
    var relatedTarget = target.parents(".upload-group").find(".file-name");
    var fileName = target[0].files[0].name;
    relatedTarget.val(fileName);
  });
  $(".upload-btn").on("click", function () {
    $(this).siblings("input:file").click();
  });
}

$(window).resize(checkWidth).trigger("resize");
$(document).ready(function () {
  App.Init();
  InitSlider();
  replaceSvg();
  Headers();
  mappings();
  selectUi();
  uploadPhoto();
  fixedNav();
  adjustProductAmount();
  accordion();
  jarallax();
  myTabs();
  checkWidth();
  $("[data-fancybox]").fancybox({
    closeExisting: true,
    loop: true,
    touch: false,
    afterLoad: function () {
      $(".slider-1").slick("setPosition", 0);
    },
  });
  $('[data-fancybox="gallery"]').fancybox({
    idleTime: false,
    baseClass: "fancybox-custom-layout",
    margin: 0,
    gutter: 0,
    infobar: false,
    smallBtn: true,
    thumbs: {
      hideOnClose: false,
      parentEl: ".fancybox-outer",
    },
    touch: {
      vertical: false,
    },
    buttons: ["close"],
    animationEffect: "fade",
    animationDuration: 300,
    helpers: { title: "top" },
    caption: function (instance, item) {
      var caption = $(this).data("caption");
      var title = $(this).data("title");
      return (
        '<div class="popup-content"> <div class="title">' +
        title +
        "</div>" +
        '<div class="caption">' +
        caption +
        "</div> </div>"
      );
    },
  });

  $('[data-fancybox="images"]').fancybox({
    baseClass: "myFancyBox",
    thumbs: {
      autoStart: true,
      axis: "x",
    },
  });
  $(".add-to-quote-popup").fancybox({
    baseClass: "popup-custom",
  });
});
